import React from "react";
import { USER_ROLES } from "static/preferences";

import { Button, Chip } from "@mui/material";
import { Add, Check } from "@mui/icons-material";

const EditRolePreference = ({ featureKey, roles, fieldKey, changeRole }) => {
  return (
    <>
      {USER_ROLES.map((role) =>
        roles.includes(role) ? (
          <Chip
            component={Button}
            icon={<Check />}
            label={role}
            color="secondary"
            clickable
            style={{ background: "#4CAF50", cursor: "pointer" }}
            onClick={() => changeRole(featureKey, fieldKey, role)}
          />
        ) : (
          <Chip
            component={Button}
            icon={<Add />}
            label={role}
            clickable
            onClick={() => changeRole(featureKey, fieldKey, role)}
            style={{
              background: "transparent",
              border: "1px solid #E0E0E0",
              cursor: "pointer",
            }}
          />
        )
      )}
    </>
  );
};

export default EditRolePreference;
